import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
    connect() {
        this.sortable = Sortable.create(this.element, {
            handle: ".drag-handle",
            animation: 150,
            onEnd: this.end.bind(this)
        })
    }

    end(event) {
        this.element.querySelectorAll(".nested-form-wrapper").forEach((item, index) => {
            item.querySelector("input[name*='position']").value = index + 1
        })
    }
}
